import React, {useState, useEffect, useCallback, useMemo, useContext} from 'react'
import {Table, Button} from 'antd'
import {useNavigate} from 'react-router-dom'
import modalAddMail from './modal-add-mail'
import modalEditMail from './modal-edit-mail'
import fetchAPI from 'src/lib/utils/fetch-api'
import {getDataOfType} from 'src/lib/utils/get-data-of-type'
import {createClientCard} from "../card-order/utils";

const TabMailContext = React.createContext({})

function ButtonEdit({id}) {
  const props = useContext<any>(TabMailContext)
  return <Button onClick={() => props.editRow(id)}>Редактировать</Button>
}

function TabMail({onChange, id}) {
  const navigate = useNavigate()

  const columns = useMemo(() => [
    {
      title: 'E-mail',
      width: 290,
      key: 'user',
      dataIndex: 'user'
    },
    {
      title: 'Пароль',
      width: 290,
      key: 'password',
      dataIndex: 'password',
    },
    {
      title: 'Хост',
      width: 290,
      key: 'host',
      dataIndex: 'host',
    },
    {
      title: 'Порт',
      width: 290,
      key: 'port',
      dataIndex: 'port',
    },
    {
      title: 'TLS',
      width: 290,
      key: 'tls',
      dataIndex: 'tls',
      render: (key, item) => (key === true) ? 'Да' : 'Нет'
    },
    {
      title: null,
      width: 290,
      key: 'edit',
      dataIndex: 'id',
      render: id => <ButtonEdit id={id}/>,
    }
  ], [])

  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [dataSource, setMails] = useState<any[]>([])
  const [selected, setSelectedMails] = useState<any[]>([])

  const getData = useCallback(async () => {
    setIsLoading(true)
    const result = await fetchAPI(`/api/organization_imap/${id}`)
    const data = getDataOfType(result, 'data', Array, [])
    setSelectedMails(data.map(item => item['id']))
    setMails(data)
    setIsLoading(false)
  }, [id])

  useEffect(() => {
    getData()
  }, [getData])

  const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>(selected)

  const onSelect = useCallback(({id}, isSelected, selectedRows) => {
    const selectedRowsKeys = selectedRows.map(item => item['id'])
    const result = isSelected
      ? selectedRowsKeys.concat(id)
      : selectedRowsKeys.filter(key => key !== id)
    onChange([...new Set(result)])
  }, [onChange])
  useEffect(() => {
    setSelectedRowKeys(selected)
  }, [selected])

  const rowSelection = useMemo(() => ({
    selectedRowKeys,
    onSelect,
    hideSelectAll: true
  }), [selectedRowKeys, onSelect])

  const onHeaderRow = useCallback((column: any) => ({
    style: {
      fontSize: (column.key && column.key.substr(-3) === '-at') ? 9 : 13,
    }
  }), [])

  const contextProps = useMemo(() => ({
    editRow: async (mailId) => {
      const formData = dataSource.find(item => item.id === mailId)
      const newFormData = await modalEditMail(formData)

      if (newFormData === null) {
        return
      }
      await fetchAPI(`/api/organization_imap/${mailId}`, {
        method: 'POST',
        body: JSON.stringify({...newFormData, organization_id: id, tls: !!newFormData.tls})
      })

      getData()
    }
  }), [history, id, dataSource])

  const addMail = useCallback(async () => {
    const formData = await modalAddMail()

    if (formData === null) {
      return
    }
    await fetchAPI(`/api/organization_imap`, {
      method: 'POST',
      body: JSON.stringify({...formData, organization_id: id, tls: !!formData.tls})
    })

    getData()

  }, [id, getData])

  return (<>
    <Button onClick={addMail}>Добавить почту</Button>
    <TabMailContext.Provider value={contextProps}>
      <Table
        size="small"
        rowKey="id"
        pagination={false}
        rowSelection={rowSelection}
        columns={columns}
        dataSource={dataSource}
        loading={isLoading}
        onHeaderRow={onHeaderRow}
      />
    </TabMailContext.Provider>
  </>)
}

export default TabMail
